"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _productForm = _interopRequireDefault(require("components/product-form"));

var Product = /*#__PURE__*/function () {
  function Product(component) {
    (0, _classCallCheck2["default"])(this, Product);
    this.dom = {
      $component: component,
      $sticky: component.querySelector('.js-product-sticky-add-to-cart'),
      $stickyContainer: component.querySelector('.js-product-sticky-container')
    }, this.state = {
      sticky: false,
      stickyClass: 'is-sticky',
      supportsIntersectionObserver: 'IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype,
      observer: false,
      observerConfig: {
        rootMargin: '-125px',
        threshold: 0
      }
    };
    this.mount();
  }

  (0, _createClass2["default"])(Product, [{
    key: "mount",
    value: function mount() {
      var state = this.state;
      console.log('Product : mount', this);

      if (state.supportsIntersectionObserver) {
        this.observe();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom,
          state = this.state;
      console.log('Product : unmount', this);
      state.observer.unobserve(dom.$stickyContainer);
    }
  }, {
    key: "observe",
    value: function observe() {
      var dom = this.dom,
          state = this.state;
      console.log('Product : observe', this);
      state.observer = new IntersectionObserver(this.onIntersection.bind(this), state.observerConfig);
      state.observer.observe(dom.$stickyContainer);
    }
  }, {
    key: "onIntersection",
    value: function onIntersection(entries) {
      var dom = this.dom,
          state = this.state;
      console.log('Product : onIntersection', this, entries);
      var entry = entries[0];
      var inview = entry.intersectionRatio > 0;

      if (inview && !state.sticky) {
        console.log('Product : onIntersection : add sticky', this, entries);
        state.sticky = true;
        dom.$component.classList.add(state.stickyClass);
      } else if (state.sticky) {
        console.log('Product : onIntersection : remove sticky', this, entries);
        state.sticky = false;
        dom.$component.classList.remove(state.stickyClass);
      }
    }
  }]);
  return Product;
}();

exports["default"] = Product;